import { action, decorate, observable, reaction } from "mobx";

class RulesStore {
  order = "asc";
  orderBy = "last-modified";
  selected = [];
  rules = [];
  page = 0;
  rowsPerPage = 10;
  totalRules = 0;
  allRules = true;
  ruleTitle = "All Rules";

  constructor(sportyApi, authStore) {
    this.sportyApi = sportyApi;
    this.authStore = authStore;

    reaction(
      () => this.page,
      page => this.getRules()
    );
    reaction(
      () => this.rowsPerPage,
      rowsPerPage => this.getRules()
    );
  }

  setRules(rules) {
    this.rules = rules;
  }

  setPage(page) {
    this.page = page;
  }

  setRowsPerPage(rowsPerPage) {
    this.rowsPerPage = rowsPerPage;
  }

  handleDelete() {
    Promise.all(
      this.selected.map(id => {
        return this.sportyApi
          .deleteRule(id, this.rowsPerPage, this.page, this.allRules)
          .then(id => this.selected.remove(id));
      })
    ).then(() => this.getRules());
  }

  // Property needs to be a field in the rule object for this to sort properly
  handleSortRequest(event, property) {
    const orderBy = property;
    let order = "desc";
    if (this.orderBy === property && this.order === "desc") {
      order = "asc";
    }

    const data =
      order === "desc"
        ? this.rules.sort((a, b) =>
            this._getSortField(b[orderBy]) < this._getSortField(a[orderBy])
              ? -1
              : 1
          )
        : this.rules.sort((a, b) =>
            this._getSortField(a[orderBy]) < this._getSortField(b[orderBy])
              ? -1
              : 1
          );
    this.order = order;
    this.orderBy = orderBy;
    this.rules = data;
  }

  handleSelectAll(event, checked) {
    if (checked) {
      this.selected = this.rules.map(r => r.ruleId);
    } else {
      this.selected = [];
    }
  }

  handleSelect(id) {
    const selectedIndex = this.selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(this.selected.slice(), id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(this.selected.slice(1));
    } else if (selectedIndex === this.selected.length - 1) {
      newSelected = newSelected.concat(this.selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        this.selected.slice(0, selectedIndex),
        this.selected.slice(selectedIndex + 1)
      );
    }

    this.selected = newSelected;
  }

  isSelected(id) {
    return this.selected.indexOf(id) !== -1;
  }

  toggleAllRules() {
    this.allRules = !this.allRules;
    if (this.allRules) {
      this.ruleTitle = "All Rules";
    } else {
      this.ruleTitle = "My Rules";
    }
    this.getRules();
  }

  async getRules() {
    return this.sportyApi
      .getRules(this.rowsPerPage, this.page, this.allRules)
      .then(data => {
        this.setRules(data.rules);
        this.totalRules = data.total;
      });
  }

  _getSortField(field) {
    if (typeof field === "string") {
      return field.toLowerCase();
    }

    return field;
  }
}

decorate(RulesStore, {
  rules: observable,
  selected: observable,
  totalRules: observable,
  page: observable,
  rowsPerPage: observable,
  setRules: action,
  setPage: action,
  setRowsPerPage: action,
  handleSelection: action,
  handleSortRequest: action
});

export default RulesStore;



// WEBPACK FOOTER //
// ./src/stores/RulesStore.js